import { UPDATE_LOCATION_INFO, UPDATE_CONNECTOR_STATUS_LOCATION_DETAIL } from './../const/index'

// ==========================================
// 1. REDUCER PRE ZOZNAM LOKÁCIÍ (FETCH_LOCATIONS - Pole)
// ==========================================
export const locationsListReducer = (state: any, action: any) => {
    if (!state) return state

    const isWrapped = state.value !== undefined
    const rawLocations = isWrapped ? state.value : state

    if (!Array.isArray(rawLocations)) return state

    switch (action.type) {
        case `${UPDATE_CONNECTOR_STATUS_LOCATION_DETAIL}`: {
            // Dáta sú zabalené v action.payload.locationInfo
            const incomingInfo = action.payload?.locationInfo
            if (!incomingInfo) return state

            // Získame ID konektora (použije Id alebo id)
            const incomingConnectorId = incomingInfo.Id ?? incomingInfo.id

            const updated = rawLocations.map((location: any) => ({
                ...location,
                chargers: location.chargers
                    ? location.chargers.map((charger: any) => ({
                          ...charger,
                          connectors: charger.connectors
                              ? charger.connectors.map((connector: any) => {
                                    // Porovnáme ID konektora v Reduxe s prichádzajúcim Id
                                    const isMatch = connector.id === incomingConnectorId

                                    return isMatch
                                        ? {
                                              ...connector,
                                              // Namapujeme hodnoty s fallbackom na malé/veľké písmená
                                              state: incomingInfo.State ?? incomingInfo.state ?? connector.state,
                                              availability: incomingInfo.Availability ?? incomingInfo.availability ?? connector.availability,
                                              active: incomingInfo.Active ?? incomingInfo.active ?? connector.active,
                                              ocppStatus: incomingInfo.OcppStatus ?? incomingInfo.ocppStatus ?? connector.ocppStatus,
                                          }
                                        : connector
                                })
                              : [],
                      }))
                    : null,
            }))

            return isWrapped ? { ...state, value: updated } : updated
        }

        case `${UPDATE_LOCATION_INFO}`: {
            const incomingInfo = action.payload.locationInfo
            if (!incomingInfo) return state

            const updated = rawLocations.map((location: any) => {
                const incomingId = incomingInfo.id || incomingInfo.Id
                if (location.id === incomingId) {
                    return {
                        ...location,
                        availableConnectors:
                            incomingInfo.availableConnectors ??
                            incomingInfo.AvailableConnectors ??
                            location.availableConnectors,
                        workingConnectors:
                            incomingInfo.workingConnectors ??
                            incomingInfo.WorkingConnectors ??
                            location.workingConnectors,
                        connectorCount:
                            incomingInfo.connectorCount ?? incomingInfo.ConnectorCount ?? location.connectorCount,
                        connectedChargers:
                            incomingInfo.connectedChargers ??
                            incomingInfo.ConnectedChargers ??
                            location.connectedChargers,
                    }
                }
                return location
            })

            return isWrapped ? { ...state, value: updated } : updated
        }

        default:
            return state
    }
}

// ==========================================
// 2. REDUCER PRE DETAIL JEDNEJ LOKÁCIE (FETCH_LOCATION_DETAIL - Objekt)
// ==========================================
export const locationDetailReducer = (state: any, action: any) => {
    if (!state) return state

    const isWrapped = state.value !== undefined
    const location = isWrapped ? state.value : state

    if (!location || typeof location !== 'object') return state

    switch (action.type) {
        case UPDATE_CONNECTOR_STATUS_LOCATION_DETAIL: {
            const incomingInfo = action.payload?.locationInfo
            
            if (!incomingInfo || !location.chargers) return state

            const incomingConnectorId = incomingInfo.Id ?? incomingInfo.id

            const updatedChargers = location.chargers.map((charger: any) => {
                // Skontrolujeme, či táto konkrétna nabíjačka obsahuje náš konektor
                const hasConnector = charger.connectors?.some((conn: any) => 
                    conn.id === incomingConnectorId
                )

                if (!hasConnector) return charger

                return {
                    ...charger,
                    connectors: charger.connectors.map((connector: any) => {
                        const isMatch = connector.id === incomingConnectorId

                        if (isMatch) {
                            return {
                                ...connector,
                                availability: incomingInfo.Availability ?? incomingInfo.availability ?? connector.availability,
                                state: incomingInfo.State ?? incomingInfo.state ?? connector.state,
                                active: incomingInfo.Active ?? incomingInfo.active ?? connector.active,
                                ocppStatus: incomingInfo.OcppStatus ?? incomingInfo.ocppStatus ?? connector.ocppStatus,
                            }
                        }
                        return connector
                    }),
                }
            })

            return {
                ...state,
                value: {
                    ...location,
                    chargers: updatedChargers
                }
            }
        }

        case `${UPDATE_LOCATION_INFO}`: {
            const incomingInfo = action.payload.locationInfo
            if (!incomingInfo) return state

            const incomingId = incomingInfo.id || incomingInfo.Id
            if (location.id !== incomingId) return state

            const updated = {
                ...location,
                availableConnectors:
                    incomingInfo.availableConnectors ??
                    incomingInfo.AvailableConnectors ??
                    location.availableConnectors,
                workingConnectors:
                    incomingInfo.workingConnectors ?? incomingInfo.WorkingConnectors ?? location.workingConnectors,
                connectorCount: incomingInfo.connectorCount ?? incomingInfo.ConnectorCount ?? location.connectorCount,
                connectedChargers:
                    incomingInfo.connectedChargers ?? incomingInfo.ConnectedChargers ?? location.connectedChargers,
            }

            return isWrapped ? { ...state, value: updated } : updated
        }

        default:
            return state
    }
}